const SMA = 
`import time
import numpy as np

token = "Your_API_Key"  # Refer to Step 2 in the User Guide above to retrieve your API Key
NSC = NUSwapConnector(token)

symbol = "BTCUSD"  # cyptocurrency code of your choice
pos_held = False

window = 5

while True:
    print("")
    print("Checking Price")
    
    market_data = NSC.getMarketHistory(symbol)
    
    close_list = []
    for data in market_data:
        close_list.append(data['close'])
    
    close_list = np.array(close_list, dtype=np.float64)
    sma = np.mean(close_list[-window:])  # Calculate the SMA over the last 'window' periods
    last_price = close_list[-1]
    
    print("Simple Moving Average (SMA): " + str(sma))
    print("Last Price: " + str(last_price))
    
    if last_price > sma and not pos_held:  # Buy signal
        print("Buy signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Buy', 1,)  # Placeholder order function. Replace with your implementation.
        pos_held = True
    
    elif last_price < sma and pos_held:  # Sell signal
        print("Sell signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Sell', 1)  # Placeholder order function. Replace with your implementation.
        pos_held = False
    
    time.sleep(60)  # Sleep for 60 seconds before checking again`

export default SMA;